import { hideMenu, toggleMobileMenu, showSubmenu } from './modules/header';
import { triggerWelcomeModal } from "./modules/welcome";
import { triggerClock } from "./modules/clock";
import { initSmoothScroll } from "./modules/smoothscroll";
import { initAnim } from "./modules/animations";
import { initAutocomplete } from './modules/autocomplete';
import { initSlider } from './modules/slider';
import { initExpandedInput } from './modules/expanded-input';
import { initTitle } from './modules/title';
import { fixTextAlignmentForApple } from './modules/font';
import { initLinks } from './modules/links';
import { initAcfFormInteractions } from './modules/form';
import { initRenewalSuccessModal } from './modules/renewal-success-modal';

const windowWidth = window.innerWidth;
const header = document.querySelector('.header');
const navbarToggler = document.querySelector('.nav-toggler');

document.addEventListener("DOMContentLoaded", function() {
  (navbarToggler && header) && toggleMobileMenu(navbarToggler, header);
  triggerWelcomeModal()
  triggerClock()
  initSmoothScroll().init()
  initAnim().init()
  initAutocomplete()
  initSlider()
  initExpandedInput()
  initTitle()
  fixTextAlignmentForApple()
  showSubmenu(header)
  initLinks()
  initAcfFormInteractions(jQuery)
  initRenewalSuccessModal()
});

window.addEventListener('resize', () => {
  (window.innerWidth != windowWidth && window.innerWidth >= 1025 && navbarToggler.classList.contains('menu-open') && hideMenu(navbarToggler, header), 100);
  initTitle()
  initLinks()
});

window.addEventListener("scroll", () => {
  const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolled = (winScroll / height) * 100;
  
  document.getElementById("progress-bar").style.width = scrolled + "%";
});
